import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service'; 
import {HelperService} from '../../services/helper.service';
import {DownloadService} from "../../services/download.service"; 
import {DmsAccessService} from "../../services/dms-access.service";
import {ExcelServicesService} from "../../services/excel-services.service";
import {TrainingService} from '../../services/training.service';
import {TosterMessageService} from '../../services/toster-message.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {IOption} from 'ng-select';
import {API_URL} from '../../config'

import { QuestionBankImportErrorsModalComponent } from "../question-bank-import-errors-modal/question-bank-import-errors-modal.component";

@Component({
  selector: 'app-question-bank-import-modal.component',
  templateUrl: './question-bank-import-modal.component.html',
  styleUrls: ['./question-bank-import-modal.component.scss'],
  providers: [TrainingService, TosterMessageService, HelperService, DownloadService, DmsAccessService, ExcelServicesService],
})
export class QuestionBankImportModalComponent implements OnInit {

  auto_id: number;
  public masterData:any = {}; 
  public appliedFilterData: any = {};
  @ViewChild('swalModal') swalModal:any;
  @ViewChild('errorMessageHtml') errorMessageHtml:any;
  @ViewChild('f') form:any;
  bsModalShowUploadErrors: BsModalRef;
  public successMsg:string = '';
  public htmlErrorMessage:string = "";
  selectedCompanySystemID = this.helperService.getSelectedCompanyId(); 
  uploadErrors: any ={
   data: {
    error_count: 0,
    success_count: 0
   }
  };
  // excel=[
  //   {'Employee Name': '', 'Staff ID': '', 'Course Name': '', 'Attended Date': ''}
  // ];
  excel=[
    {'Question Type': '', 'Question': '', 'Answer': '', 'Is Correct': '', 'Marks': ''}
  ];
  constructor(public bsModalRef:BsModalRef, 
              private tosterMessageService: TosterMessageService,
              private helperService:HelperService,
              private http: HttpClient,
              private downloadService: DownloadService,
              private spinner: NgxSpinnerService,
              private dmsAccessService: DmsAccessService,
              private excelService: ExcelServicesService,
              private modalService:BsModalService) {
  } 

  ngOnInit() {
    this.modalService.onHide.subscribe((reason: string, event) => {
      if (reason) {
        if (reason === 'upload_closed') {
          this.closeModal();
        }
      }
    }); 

    this.auto_id = Number(localStorage.getItem("question-bank-import-auto-id"));
    console.log(this.auto_id);
    localStorage.removeItem("question-bank-import-auto-id");
  }

  showErrorHtml() {
    setTimeout(()=> {
      this.errorMessageHtml.show();
    }, 0)
  }

  showSuccessHtml() {
    setTimeout(()=> {
      this.swalModal.show();
    }, 0)
  } 

  changeListener(files: FileList){ 
    let that = this;
    if(files && files.length > 0) {
      let file : File = files.item(0); 
      that.masterData.file = file;
    }
  }

  uploadFile() { 
    
    let that = this; 
    console.log(that.masterData.file);
    console.log(that.auto_id);

    if(that.masterData.file){
      that.masterData.companySystemID = that.selectedCompanySystemID;   
      that.masterData.auto_id = that.auto_id;   
      let reader: FileReader = new FileReader();  
      const headersConfig = that.downloadService.createAuthHeaderFileUpload();
      const filename: string = API_URL+'/api/v1/uploadQuestionBankCSVData'; 
      let formData: FormData = new FormData();
      formData.append('file', that.masterData.file, that.masterData.file.name); 

      formData.append('companySystemID', that.masterData.companySystemID);
      formData.append('auto_id', that.masterData.auto_id);


      that.http.post(filename, formData,
        {
          headers: headersConfig, 
        }
      ).subscribe(data => {
        that.uploadErrors = data;
        that.successMsg = '';
        that.successMsg = 'Successfully added ' + that.uploadErrors.data.success_count + ' Excel data with ' + this.uploadErrors.data.error_count + ' errors.';
        that.showSuccessHtml();
        //that.closeModalAfterCreate()
      }, (error) => {
        console.log(error);
        that.tosterMessageService.showError('Error', error.error.message);
      });
    }else{ 
      that.tosterMessageService.showError('Error', 'Please choose a file.');
    }  

  }  






  public exportToCSV() {
    this.excelService.exportAsExcelFile(this.excel, 'question_bank_import');
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('upload_closed');
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('upload_closed');
  }


  

  showErrors(){
    this.bsModalShowUploadErrors = this.modalService.show(QuestionBankImportErrorsModalComponent, {
      class: 'modal-lg',
      backdrop: 'static'
    }); 
    this.bsModalShowUploadErrors.content.uploadErrors = this.uploadErrors.data.errors;
  }



}



// WEBPACK FOOTER //
// /app/src/app/competancy/question-bank-import-modal/question-bank-import-modal.component.ts